import React, { useState, useEffect, useCallback, useRef } from 'react';
import { Span, Div, Flex } from "../../../style";
import { Button, Paper } from "@mui/material";
import Avatar from '@mui/material/Avatar';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import '@react-pdf-viewer/core/lib/styles/index.css';
import getCookie from '../../../hooks/getCookie';
import { getAvatarUrl } from '../../../utils/getAvatarUrl';
//import MentionTextArea from '../../MentionTextArea';

function CommentsPadrao() {
    const modules = {
        toolbar: [
            ['bold', 'italic', 'underline', 'strike', 'blockquote'],
            [{ 'list': 'ordered' }, { 'list': 'bullet' },
            { 'indent': '-1' }, { 'indent': '+1' }],
            ['image'],
        ],
    };
        return (
            <Div className='comment' >
                <Flex>
                    <Avatar
                      className="comment-avatar"
                      src={getAvatarUrl("lesteboard")}
                      sx={{ width: 24, height: 24, ml: -1 }}
                      title="Lesteboard"
                    />
                    <div>
                        <Flex>
                            <Span className='user-comments'>{"Sou apenas um comentário de exemplo"}</Span>
                            <Span className='comment-timestamp'>{"Lesteboard"}</Span>
                        </Flex>
                            <div style={{ display: 'flex' }}>
                                <Button className='edit-button' >
                                    <EditIcon style={{ fontSize: '0.7rem' }} />Editar
                                </Button>
                                <Button className='delete-button' >
                                    <DeleteIcon style={{ fontSize: '0.7rem' }} />Excluir
                                </Button>
                            </div>
                    </div>
                </Flex>
            </Div>
        );
}

export default CommentsPadrao;